/**
 *
 * SectionFields
 *
 */
import React, { memo, useMemo } from 'react';
import classNames from 'classnames';

// antd component
import { Form, Input } from 'antd';
const { TextArea } = Input;

import { useTranslation} from "react-i18next";

function SectionFields({
  name,
  sectionValues,
  required,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-field-row', className);
  const { t, i18n } = useTranslation();

  const sectionTitle = useMemo(() => (
    <Form.Item
      name={[name, `${name}-title`]}
      key={[name, `${name}-title`]}
      rules={[
        {
          required: !!required,
          message: t("inputs.mandatoryField"),
          validateTrigger: ["onChange", "onSubmit"],
        },
        {
          type: 'string',
          min: 6,
          validateTrigger: ["onChange", "onSubmit"],
          message: t("inputs.minimumCharacters", { min: 6 }),
        }
      ]}
      label={t("inputs.formTitle")}
      className="input"
    >
      <Input
        placeholder={t("inputs.formTitle")}
      />
    </Form.Item>
  ), [name, sectionValues, required, i18n?.language]);

  const sectionDescription = useMemo(() => (
    <Form.Item
      name={[name, `${name}-description`]}
      key={[name, `${name}-description`]}
      rules={[
        {
          required: false,
        },
        {
          type: 'string',
          min: 6,
          validateTrigger: ["onChange", "onSubmit"],
          message: t("inputs.minimumCharacters", { min: 6 }),
        }
      ]}
      label={t("inputs.description")}
      className="textarea"
    >
      <TextArea
        rows={4}
        placeholder={t("inputs.optionalDescription")} minLength={6} />
    </Form.Item>
  ), [name, i18n?.language]);

  return name && (
    <div className={childClassNames}>
      {sectionTitle}
      {sectionDescription}
    </div>
  );
};

SectionFields.defaultProps = {
  required: true
};

export default memo(SectionFields);
